import { all } from 'redux-saga/effects';

import global from './global/sagas';
import login from './login/sagas';
import usuario from './usuario/sagas';

export default function* rootSaga(): any {
  return yield all([global,login,usuario]);
}
